import {Component, Inject, OnInit, ViewChild} from '@angular/core';
import {Router} from '@angular/router';
import {SigninService} from '../signin.service';
import {FieldComponent} from '../field/field.component';
import {CheckboxComponent} from '../checkbox/checkbox.component';

@Component({
  selector: 'app-login',
  templateUrl: './login.component.html',
  styleUrls: ['./login.component.scss']
})
export class LoginComponent implements OnInit {

  @ViewChild("login") login: FieldComponent;
  @ViewChild("pass") pass: FieldComponent;
  @ViewChild("txi") txi: CheckboxComponent;
  @ViewChild("vsl") vsl: CheckboxComponent;
  @ViewChild("aba") aba: CheckboxComponent;

  type: string;

  constructor(
    @Inject('signin') private signin: SigninService,
    private router: Router
  ) {
  }

  isValid(){
    let pattern = new RegExp("^[0-9]{9,}$");
    return pattern.test(this.login.value.trim());
  }

  ngOnInit() {
    if (this.signin.session){
      this.router.navigateByUrl("dashboard");
      return;
    }
    this.signin.clearSessionEvent.subscribe(() => {
      this.login.value = "";
      this.pass.value = "";
    })
  }

  connect(){
    this.signin.createSession(this.login.value.trim(), this.pass.value.trim(), this.type);
    this.router.navigateByUrl('dashboard');
  }

  update(motif: string){
    switch(motif){
      case 'txi':
        this.vsl.checked = false;
        this.aba.checked = false;
        if (this.txi.checked){
          this.type = 'txi';
        } else {
          this.type = null;
        }
      break;

      case 'vsl':
        this.txi.checked = false;
        this.aba.checked = false;
        if (this.vsl.checked){
          this.type = 'vsl';
        } else {
          this.type = null;
        }
      break;

      case 'aba':
        this.vsl.checked = false;
        this.txi.checked = false;
        if (this.aba.checked){
          this.type = 'aba';
        } else {
          this.type = null;
        }
      break;

      default:
        // nothing
    }
  }
}



// WEBPACK FOOTER //
// ./src/app/login/login.component.ts